import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6vj74fwatr: FaireBrandEntity = {
  token: "b_6vj74fwatr",
  type: "brand",
  name: "Flying S Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/ac75fb7a8f1cf96bf76f6010ac3fbb00dd8e8b65ae077b9fed76e85e85af0f44.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0888af5e2415f46652b52439488036b0be0ff0512c745d6ca18be7ec13063825.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ac75fb7a8f1cf96bf76f6010ac3fbb00dd8e8b65ae077b9fed76e85e85af0f44.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0888af5e2415f46652b52439488036b0be0ff0512c745d6ca18be7ec13063825.jpeg",
  location: "Madill, OK, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 148,
  isTopShop: true,
  isInsider: true,
  description:
    "Howdy friends! Flying S offers you a variety of trendsetting designs. We work hard to develop original designs and products that are sure to help set your business apart. Having grown up on a commercial cattle operation in southern Oklahoma, where CEO Shiann and her husband continue to pass down the family tradition of ranching to their two daughters, Flying S designs are authentic to our western roots. At Flying S we pride ourselves on excellent customer service, originality, and quality and we know you won’t be disappointed shopping Flying S!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:42.144Z",
    importedBy: "entity-db-cli",
  },
};
